import {
  componentsTranslation,
  ComponentsTranslation,
} from '@/assets/locales/components/components.translation.en.ts';
import {
  generalErrorTranslation,
  GeneralErrorTranslation,
} from '@/assets/locales/generalError/generalError.translation.en.ts';
import {
  layoutsTranslation,
  LayoutsTranslation,
} from '@/assets/locales/layouts/layouts.translation.en';
import { menuTranslation, MenuTranslation } from '@/assets/locales/menu/menu.translation.en.ts';
import {
  PageTitlesTranslation,
  pageTitlesTranslation,
} from '@/assets/locales/pageTitles/pageTitles.translation.en.ts';
import { utilsTranslation, UtilsTranslation } from '@/assets/locales/utils/utils.translation.en.ts';
import {
  validationTranslation,
  ValidationTranslation,
} from '@/assets/locales/validation/validation.translation.en';
import { viewsTranslation, ViewsTranslation } from '@/assets/locales/views/views.translation.en';

export const NAMESPACE = 'aicvorange';

export interface Translations {
  [NAMESPACE: string]: {
    alerts: Record<string, unknown>;
    components: ComponentsTranslation;
    fullText: Record<string, unknown>;
    generalError: GeneralErrorTranslation;
    layouts: LayoutsTranslation;
    menu: MenuTranslation;
    pageTitles: PageTitlesTranslation;
    utils: UtilsTranslation;
    validation: ValidationTranslation;
    views: ViewsTranslation;
  };
}

export const en: Translations = {
  [NAMESPACE]: {
    alerts: {
      error: 'The operation has failed, try again or contact the application administrator.',
      success: 'Operation completed successfully.',
    },
    components: componentsTranslation,
    fullText: {
      all: 'All',
      goBack: 'Go back',
      maxResults: 'Maximum results per page',
      missing: 'Missing:',
      more: 'more...',
      resultCount: 'Search results: ',
    },
    generalError: generalErrorTranslation,
    layouts: layoutsTranslation,
    menu: menuTranslation,
    pageTitles: pageTitlesTranslation,
    utils: utilsTranslation,
    validation: validationTranslation,
    views: viewsTranslation,
  },
};
